<ng-container [formGroup]="formGroup">
  <label class="o-form-check o-form-check__label" [for]="'ckb-' + controlName">
    <input
      class="o-form-check__input"
      type="checkbox"
      [id]="'ckb-' + controlName"
      [formControlName]="controlName"
    >
    <span class="o-form-check__btn o-form-check__content">
      <span *ngIf="required" class="pseic-form-field-label-required-asterisk">*</span>
      <ng-content></ng-content>
    </span>
  </label>
  <pseic-form-field-errors [control]="control"
                           [resizeOnError]="resizeOnError"
  ></pseic-form-field-errors>
</ng-container>
